export enum ContextMenuStatusEnum {
	IDLE = 'idle',
	OPENED = 'opened',
	CLOSED = 'closed',
}
